export default "__VITE_ASSET__DkAmJKsp__"